<template>
  <div class="home">
    <!-- banner -->
    <home-banner ref="homeBanner" :height="650"></home-banner>

    <div class="mian mainHome">
      <div class="wrap">
        <!-- 热点新闻 -->
        <div class="home_pre clearfloat">
          <div class="home_pre_l fl"></div>
          <div class="inner">
            <el-carousel height="120px" direction="vertical" :interval="2500" indicator-position="none">
              <el-carousel-item v-for="item in newsTop" :key="item.entTArticleUuid">
                <div class="homeTopInner">
                  <h3 class="single-line" style="text-align:center">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">{{ item.title }}</a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{
                      item.title
                    }}</a>
                  </h3>
                  <p style="margin-top:20px">
                    {{ item.artDesc }}
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url"
                      >&nbsp;&nbsp;&nbsp;&nbsp;查看详情>></a
                    >
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      >&nbsp;&nbsp;&nbsp;&nbsp;查看详情>></a
                    >
                  </p>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="wrap">
        <div class="homeNews">
          <!-- 新闻中心 -->
          <ul class="nav nav_tabs">
            <li
              class="nav_tabs_li"
              :class="{ active: activeNewsHd == index }"
              v-for="(item, index) in newsHdList"
              :key="index + 'dec01'"
              @mouseenter="mouseenterNewsHd(index)"
            >
              <a :href="item.url" target="_balnk">{{ item.title }}</a>
            </li>
            <li class="last_li">
              <div></div>
            </li>
          </ul>
          <el-row :gutter="40">
            <el-col :span="13">
              <div class="homeNewsBox">
                <ul class="big_List" v-if="activeNewsHd == 0">
                  <li v-for="(item, index) in newsRight01" :key="index">
                    <div class="big_List_L">
                      <div class="u">{{ dayjs(item.publishDate).format('DD') }}</div>
                      <div class="d">{{ dayjs(item.publishDate).format('YYYY-MM') }}</div>
                    </div>
                    <a class="big_List_R" v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <img class="big_List_R_l" :src="newsRight01img[index].thumb1" />
                      <div class="big_List_R_r">
                        <a class="big_List_R_r_top">{{ item.title }}</a>
                        <a class="big_List_R_r_artDesc">{{ item.artDesc | ellipsis }}</a>
                      </div>
                    </a>
                    <!-- <a class="big_List_R" v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"> -->
                    <a class="big_List_R" v-else target="_blank" :href="`/detail/00890001/${item.entTArticleUuid}`">
                      <img class="big_List_R_l" :src="newsRight01img[index].thumb1" />
                      <div class="big_List_R_r">
                        <a class="big_List_R_r_top">{{ item.title }}</a>
                        <a class="big_List_R_r_artDesc">{{ item.artDesc | ellipsis }}</a>
                      </div>
                    </a>
                  </li>
                </ul>
                <ul class="big_List" v-if="activeNewsHd == 1">
                  <li v-for="(item, index) in newsRight02" :key="index">
                    <div class="big_List_L">
                      <div class="u">{{ dayjs(item.publishDate).format('DD') }}</div>
                      <div class="d">{{ dayjs(item.publishDate).format('YYYY-MM') }}</div>
                    </div>
                    <a class="big_List_R" v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <img class="big_List_R_l" :src="newsRight02img[index].thumb1" />
                      <div class="big_List_R_r">
                        <a class="big_List_R_r_top">{{ item.title }}</a>
                        <a class="big_List_R_r_artDesc">{{ item.artDesc | ellipsis }}</a>
                      </div>
                    </a>
                    <a
                      class="big_List_R"
                      v-else
                      target="_blank"
                      :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                    >
                      <img class="big_List_R_l" :src="newsRight02img[index].thumb1" />
                      <div class="big_List_R_r">
                        <a class="big_List_R_r_top">{{ item.title }}</a>
                        <a class="big_List_R_r_artDesc">{{ item.artDesc | ellipsis }}</a>
                      </div>
                    </a>
                  </li>
                </ul>
                <ul class="big_List" v-if="activeNewsHd == 2">
                  <li v-for="(item, index) in newsRight03" :key="index">
                    <div class="big_List_L">
                      <div class="u">{{ dayjs(item.publishDate).format('DD') }}</div>
                      <div class="d">{{ dayjs(item.publishDate).format('YYYY-MM') }}</div>
                    </div>
                    <a class="big_List_R" v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <img class="big_List_R_l" :src="newsRight03img[index].thumb1" />
                      <div class="big_List_R_r">
                        <a class="big_List_R_r_top">{{ item.title }}</a>
                        <a class="big_List_R_r_artDesc">{{ item.artDesc | ellipsis }}</a>
                      </div>
                    </a>
                    <a
                      class="big_List_R"
                      v-else
                      target="_blank"
                      :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                    >
                      <img class="big_List_R_l" :src="newsRight03img[index].thumb1" />
                      <div class="big_List_R_r">
                        <a class="big_List_R_r_top">{{ item.title }}</a>
                        <a class="big_List_R_r_artDesc">{{ item.artDesc | ellipsis }}</a>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :span="11">
              <div class="homeNannerBox" style="padding-top: 30px;">
                <div class="swiper-container bannerHomeSec01" id="bannerHomeSec01" v-show="activeNewsHd == 0">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in newsLeft01" :key="index">
                      <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                        <img :src="item.thumb1" alt="" />
                        <p class="single-line">{{ item.title }}</p>
                      </a>
                      <a v-else target="_blank" :href="`/detail/00890001/${item.entTArticleUuid}`">
                        <img :src="item.thumb1" alt="" />
                        <p class="single-line">{{ item.title }}</p>
                      </a>
                    </div>
                  </div>
                  <div class="swiper-pagination swiper-pagination-sec01"></div>
                </div>

                <div class="swiper-container bannerHomeSec01" id="bannerHomeSec02" v-show="activeNewsHd == 1">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in newsLeft02" :key="index">
                      <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                        <img :src="item.thumb1" alt="" />
                        <p class="single-line">{{ item.title }}</p>
                      </a>
                      <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                        <img :src="item.thumb1" alt="" />
                        <p class="single-line">{{ item.title }}</p>
                      </a>
                    </div>
                  </div>
                  <div class="swiper-pagination swiper-pagination-sec02"></div>
                </div>

                <div class="swiper-container bannerHomeSec01" id="bannerHomeSec03" v-show="activeNewsHd == 2">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in newsLeft03" :key="index">
                      <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                        <img :src="item.thumb1" alt="" />
                        <p class="single-line">{{ item.title }}</p>
                      </a>
                      <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                        <img :src="item.thumb1" alt="" />
                        <p class="single-line">{{ item.title }}</p>
                      </a>
                    </div>
                  </div>
                  <div class="swiper-pagination swiper-pagination-sec03"></div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 不忘初心 牢记使命 -->
      <div class="noticDec"></div>

      <!-- 党的建设 -->
      <div class="companyDec">
        <div class="wrap">
          <ul class="nav nav_tabs bgtu_dangjian">
            <li
              class="nav_tabs_li"
              :class="{ active: activeNewsHd01 == index }"
              v-for="(item, index) in newsHdList01"
              :key="index + 'com01'"
              @mouseenter="mouseenterNewsHd01(index)"
            >
              <a :href="item.url" target="_balnk">{{ item.title }}</a>
            </li>
            <li class="last_li">
              <div></div>
            </li>
          </ul>
          <div class="companyDecBox">
            <el-row>
              <el-col :span="12">
                <div class="swiper-container companyDecBox01" id="companyDecBox01" v-show="activeNewsHd01 == 0">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in companyDecBox01List" :key="index">
                      <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                        <img :src="item.thumb1" alt="" />
                        <p class="single-line">{{ item.title }}</p>
                      </a>
                      <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                        <img :src="item.thumb1" alt="" />
                        <p class="single-line">{{ item.title }}</p>
                      </a>
                    </div>
                  </div>
                  <div class="swiper-pagination swiper-pagination-com01"></div>
                  <div class="swiper-button-prev swiper-button-prev-com01"></div>
                  <div class="swiper-button-next swiper-button-next-com01"></div>
                </div>
                <div class="swiper-container companyDecBox01" id="companyDecBox02" v-show="activeNewsHd01 == 1">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in companyDecBox02List" :key="index">
                      <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                        <img :src="item.thumb1" alt="" />
                        <p class="single-line">{{ item.title }}</p>
                      </a>
                      <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                        <img :src="item.thumb1" alt="" />
                        <p class="single-line">{{ item.title }}</p>
                      </a>
                    </div>
                  </div>
                  <div class="swiper-pagination swiper-pagination-com02"></div>
                  <div class="swiper-button-prev swiper-button-prev-com02"></div>
                  <div class="swiper-button-next swiper-button-next-com02"></div>
                </div>
              </el-col>
              <el-col :span="12">
                <ul class="news_list" v-if="activeNewsHd01 == 0">
                  <li v-for="(item, index) in companyDecRList01" :key="index">
                    <div class="news_list_time fr">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</div>
                    <p class="news_list_inner single-line">
                      <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">{{ item.title }}</a>
                      <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{
                        item.title
                      }}</a>
                    </p>
                  </li>
                </ul>
                <ul class="news_list" v-if="activeNewsHd01 == 1">
                  <li v-for="(item, index) in companyDecRList02" :key="index">
                    <div class="news_list_time fr">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</div>
                    <p class="news_list_inner single-line">
                      <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">{{ item.title }}</a>
                      <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{
                        item.title
                      }}</a>
                    </p>
                  </li>
                </ul>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <!-- 关于我们 -->
      <div class="index_about_panel">
        <div class="content">
          <div class="u main_1200">
            <div class="picture pull-left">
              <a href="/listPage/00880001" target="_blank"
                ><img class="hoverBig" src="../assets/img_sj/461025dc-fc25-449e-8309-d4acb7716519.jpg"
              /></a>
            </div>
            <div class="text pull-right">
              <div class="t">
                <div class="t_l">
                  <a href="/listPage/00880001" target="_blank">关于我们</a>
                </div>
                <div class="t_r">
                  <div></div>
                </div>
              </div>
              <div class="intro">
                甘肃省建设设计咨询集团有限公司（简称“设计咨询集团”）隶属于中国500强企业——甘肃省建设投资（控股）集团有限公司，拥有建筑行业（建筑工程）设计甲级、市政行业（给水工程、排水工程、道路工程）专业乙级、岩土工程勘察乙级、风...
              </div>
              <div class="check_more">
                <a href="/listPage/00880001" target="_blank">点击详情&gt;&gt;</a>
              </div>
            </div>
          </div>
          <div class="d main_1200">
            <div class="about_cate">
              <ul>
                <li class="item1 text-center"><a href="/list/00880002">领导简介</a></li>
                <li class="item2 text-center"><a href="/listPage/00880001">组织机构</a></li>
                <li class="item4 text-center"><a href="/list/00880003">企业资质</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- 企业荣誉 -->
      <div class="honorDec">
        <div class="wrap">
          <div class="t" style="margin-bottom:40px">
            <div class="t_l">
              <div></div>
            </div>
            <div class="t_c text-center">
              <a href="/list/00880004" target="_blank">企业荣誉</a>
            </div>
            <div class="t_r">
              <div></div>
            </div>
          </div>
          <div class="honorDecBox">
            <div class="swiper-container bannerPoint bannerHonor">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in pointImgList" :key="index">
                  <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                    <div class="pic">
                      <img class="img_c1" :src="item.thumb1" alt="" />
                    </div>
                  </a>
                  <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                    <div class="pic">
                      <img class="img_c1" :src="item.thumb1" alt="" />
                    </div>
                  </a>
                </div>
              </div>
              <div class="swiper-pagination swiper-pagination-honor"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 职工园地 -->
      <div class="cultureDec">
        <div class="wrap">
          <div class="cultureBox">
            <div class="cultureWrap">
              <el-row :gutter="40">
                <el-col :span="12">
                  <div class="homeNewsHd" style="margin-bottom: 50px">
                    <ul class="nav nav_tabs bgtu_yuandi">
                      <li
                        class="nav_tabs_li_1"
                        :class="{ active: activeNewsHdCulture == index }"
                        v-for="(item, index) in newsHdCultureList"
                        :key="index + 'dec05'"
                        @mouseenter="mouseenterNewsHdCulture(index)"
                      >
                        <a style="cursor: pointer;">{{ item.title }}</a>
                      </li>
                    </ul>
                  </div>
                  <div class="cultureImg" v-if="activeNewsHdCulture == 0">
                    <ul class="news_list">
                      <li v-for="(item, index) in cultureList01" :key="index">
                        <div class="news_list_time fr">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</div>
                        <p class="news_list_inner single-line">
                          <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">{{ item.title }}</a>
                          <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{
                            item.title
                          }}</a>
                        </p>
                      </li>
                    </ul>
                  </div>
                  <div class="cultureImg" v-if="activeNewsHdCulture == 1">
                    <ul class="news_list">
                      <li v-for="(item, index) in cultureList02" :key="index">
                        <div class="news_list_time fr">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</div>
                        <p class="news_list_inner single-line">
                          <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">{{ item.title }}</a>
                          <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{
                            item.title
                          }}</a>
                        </p>
                      </li>
                    </ul>
                  </div>
                  <div class="cultureImg" v-if="activeNewsHdCulture == 2">
                    <ul class="news_list">
                      <li v-for="(item, index) in cultureList03" :key="index">
                        <div class="news_list_time fr">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</div>
                        <p class="news_list_inner single-line">
                          <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">{{ item.title }}</a>
                          <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{
                            item.title
                          }}</a>
                        </p>
                      </li>
                    </ul>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="homeNewsBox">
                    <div class="homeNewsHd" style="margin-bottom: 50px">
                      <ul class="nav nav_tabs bgtu_gonggao">
                        <li class="nav_tabs_li_1" :class="{ active: true }">
                          <a href="" target="_balnk">公示公告</a>
                        </li>
                        <div class="nav_tabs_li_1_r"></div>
                      </ul>
                    </div>
                    <ul class="news_list">
                      <li v-for="(item, index) in cultureList04" :key="index">
                        <div class="news_list_time fr">{{ dayjs(item.publishDate).format('MM-DD') }}</div>
                        <p class="news_list_inner single-line">
                          <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">{{ item.title }}</a>
                          <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">{{
                            item.title
                          }}</a>
                        </p>
                      </li>
                    </ul>
                    <a class="jcjbimg" href="/report" target="_blank">
                      <img src="../assets/img_sj/jj2.jpg" />
                    </a>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>

      <!-- 企业业绩 -->
      <div class="casesDec">
        <div class="wrap">
          <div class="honorDec">
            <div class="t bgtu_yeji">
              <div class="t_l">
                <div></div>
              </div>
              <div class="t_c text-center">
                <a href="/listPic/00880005" target="_blank">企业业绩</a>
              </div>
              <div class="t_r">
                <div></div>
              </div>
            </div>
          </div>
          <div class="casesBox">
            <div class="homeNewsHd">
              <span
                class="homeNewsHdInner"
                :class="{ active: activeNewsHdCase == index }"
                v-for="(item, index) in newsHdCaseList"
                :key="index + 'dec04'"
                @mouseenter="mouseenterNewsHdCase(index)"
              >
                <a :href="item.url" target="_blank">{{ item.title }}</a>
              </span>
            </div>
            <div class="casesWrap">
              <el-row :gutter="40" v-if="activeNewsHdCase == 0">
                <el-col :span="8" style="width:408px;height: 452px;">
                  <a
                    class="caseList2"
                    :href="`/detail/${caseList01First.entTChannelUuid}/${caseList01First.entTArticleUuid}`"
                    target="_blank"
                    style="width: 100%;height:100%;float:left;cursor: pointer;position: relative;overflow: hidden;"
                  >
                    <img :src="caseList01First.thumb1" style="width:100%;height:100%" />
                    <div class="caseLisTitle trans">
                      <span>
                        {{ caseList01First.title }}
                      </span>
                    </div>
                    <div class="caseLisTxt trans single-line">
                      <!-- {{caseList01[0].title}} -->
                    </div>
                    <div class="caseLisBg"></div>
                  </a>
                </el-col>
                <el-col :span="16">
                  <ul class="caseList clearfloat">
                    <li v-for="(item, index) in caseList01" :key="index">
                      <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                        <img :src="item.thumb1" alt="" />
                        <div class="caseLisTitle trans">
                          <span>
                            {{ item.title }}
                          </span>
                        </div>
                        <div class="caseLisTxt trans single-line">
                          <!-- {{item.title}} -->
                        </div>
                        <div class="caseLisBg"></div>
                      </a>
                      <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                        <img :src="item.thumb1" alt="" />
                        <div class="caseLisTitle trans">
                          <span>
                            {{ item.title }}
                          </span>
                        </div>
                        <div class="caseLisTxt trans single-line">
                          <!-- {{item.title}} -->
                        </div>
                        <div class="caseLisBg"></div>
                      </a>
                    </li>
                  </ul>
                </el-col>
              </el-row>
              <el-row :gutter="40" v-if="activeNewsHdCase == 1">
                <el-col :span="8" style="width:408px;height: 452px;">
                  <a
                    class="caseList2"
                    :href="`/detail/${caseList02First.entTChannelUuid}/${caseList02First.entTArticleUuid}`"
                    target="_blank"
                    style="width: 100%;height:100%;float:left;cursor: pointer;position: relative;overflow: hidden;"
                  >
                    <img :src="caseList02First.thumb1" style="width:100%;height:100%" />
                    <div class="caseLisTitle trans">
                      <span>
                        {{ caseList02First.title }}
                      </span>
                    </div>
                    <div class="caseLisTxt trans single-line">
                      <!-- {{caseList01[0].title}} -->
                    </div>
                    <div class="caseLisBg"></div>
                  </a>
                </el-col>
                <el-col :span="16">
                  <ul class="caseList clearfloat">
                    <li v-for="(item, index) in caseList02" :key="index">
                      <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                        <img :src="item.thumb1" alt="" />
                        <div class="caseLisTitle trans">
                          <span>
                            {{ item.title }}
                          </span>
                        </div>
                        <div class="caseLisTxt trans single-line">
                          <!-- {{item.title}} -->
                        </div>
                        <div class="caseLisBg"></div>
                      </a>
                      <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                        <img :src="item.thumb1" alt="" />
                        <div class="caseLisTitle trans">
                          <span>
                            {{ item.title }}
                          </span>
                        </div>
                        <div class="caseLisTxt trans single-line">
                          <!-- {{item.title}} -->
                        </div>
                        <div class="caseLisBg"></div>
                      </a>
                    </li>
                  </ul>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>

      <!-- 友情链接 -->
      <div class="wrap linkBox">
        <el-row :gutter="50" style="width:1200px;margin:auto">
          <el-col :span="6">
            <el-select
              v-model="linkValue01"
              placeholder="请选择"
              size="small"
              style="width: 100%;"
              @change="changeLink01"
            >
              <el-option v-for="(item, index) in linkList01" :key="index" :label="item.title" :value="item.url">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select
              v-model="linkValue02"
              placeholder="请选择"
              size="small"
              style="width: 100%;"
              @change="changeLink02"
            >
              <el-option v-for="(item, index) in linkList02" :key="index" :label="item.title" :value="item.url">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select
              v-model="linkValue03"
              placeholder="请选择"
              size="small"
              style="width: 100%;"
              @change="changeLink03"
            >
              <el-option v-for="(item, index) in linkList03" :key="index" :label="item.title" :value="item.url">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select
              v-model="linkValue04"
              placeholder="请选择"
              size="small"
              style="width: 100%;"
              @change="changeLink04"
            >
              <el-option v-for="(item, index) in linkList04" :key="index" :label="item.title" :value="item.url">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper'
import homeBanner from '@/components/banner/bannerFade.vue'
import { getTopArtList, picArticles, articles, picArticlesSecond, getPageInfo } from '@/api/common'
export default {
  components: {
    homeBanner
  },
  name: 'home',
  data() {
    return {
      activeNewsHd01: 0,
      activeNewsHd: 0,
      activeNewsHdCase: 0,
      activeNewsHdCulture: 0,
      newsHdList: [
        {
          title: '建投要闻',
          url: '/list/00890001'
        },
        {
          title: '公司要闻',
          url: '/list/00890002'
        },
        {
          title: '基层动态',
          url: '/list/00890003'
        }
      ],
      newsHdList01: [
        {
          title: '党的建设',
          url: '/list/00900003'
        },
        {
          title: '企业文化',
          url: '/list/00910001'
        }
      ],
      newsHdCaseList: [
        {
          title: '住宅类',
          url: '/listPic/00980001'
        },
        {
          title: '商业类',
          url: '/listPic/00980002'
        }
      ],
      newsHdCultureList: [
        {
          title: '职工园地',
          url: '/list/00350001'
        },
        {
          title: '学习园地',
          url: '/list/00350003'
        },
        {
          title: '资料中心',
          url: '/list/00350003'
        }
      ],
      activeNewsHdDes02: 0,
      newsHdListDes02: [
        {
          title: '学习教育',
          url: '/list/0076'
        },
        {
          title: '行业动态',
          url: '/list/00700002'
        }
      ],
      newsTop: [],
      newsLeft: [],
      newsLeft01: [],
      newsLeft02: [],
      newsLeft03: [],
      newsRight01: [],
      newsRight02: [],
      newsRight03: [],
      companyDecBox01List: [],
      companyDecBox02List: [],
      newsRight01img: [],
      newsRight02img: [],
      newsRight03img: [],
      homeNoticeList: [],
      homeDec02Url: '',
      homeDec02ImgUrl: '',
      homeNewsPeriodicalList: [],
      newsNotice: [],
      homeNewsBasicList: [],
      homeNewsTopDj: {},
      homeNewsTopXxjy: {},
      homeNewsTopHydt: {},
      homeNewsDjList: [],
      homeNewsXxjyList: [],
      homeNewsHydtList: [],
      pointImgList: [],
      specailList: [],
      newsNotice01: [],
      newsNotice02: [],
      homeNewsBasicTop01: {},
      homeNewsBasicTop02: {},
      homeNewsBasicList01: [],
      homeNewsBasicList02: [],
      caseList01: [],
      caseList02: [],
      caseList01First: [],
      caseList02First: [],
      cultureImg01: {},
      cultureImg02: {},
      cultureImg03: {},
      cultureImg04: {},
      cultureList01: [],
      cultureList02: [],
      cultureList03: [],
      cultureList04: [],
      linkValue01: ' ----内部链接---- ',
      linkValue02: ' ----政府链接---- ',
      linkValue03: ' ----行业链接---- ',
      linkValue04: ' ----媒体链接---- ',
      linkList01: [
        {
          title: '甘肃省建设投资（控股）集团总公司 ',
          url: 'http://www.gsjtw.cc'
        },
        {
          title: '甘肃第一建设集团有限责任公司 ',
          url: 'http://www.gsyj.com.cn'
        },
        {
          title: '甘肃第二建设集团有限责任公司 ',
          url: 'http://www.gsejjt.cn/'
        },
        {
          title: '甘肃第三建设集团公司',
          url: 'http://www.gssanjian.com'
        },
        {
          title: '甘肃第四建设集团有限责任公司 ',
          url: 'http://www.gssjjt.com'
        },
        {
          title: '甘肃第五建设集团公司 ',
          url: 'http://www.gs5j.com'
        },
        {
          title: '甘肃第六建设集团股份有限公司 ',
          url: 'http://www.gsljw.com'
        },
        {
          title: '甘肃第七建设集团股份有限公司 ',
          url: 'http://www.gs7j.com.cn'
        },
        {
          title: '甘肃省第八建设集团有限责任公司 ',
          url: 'http://www.gs8j.com'
        },
        {
          title: '甘肃第九建设集团公司 ',
          url: 'http://www.gs9j.com'
        },
        {
          title: '华陇国际产业投资有限公司 ',
          url: 'http://www.gsjthltz.com/'
        },
        {
          title: '甘肃建投智能工程有限公司 ',
          url: 'http://www.gsjtzn.com/'
        },
        {
          title: '甘肃省安装建设集团公司 ',
          url: 'http://www.gsazjsjt.com'
        },
        {
          title: '甘肃建总置业发展有限公司 ',
          url: 'http://gsjiantouzhiye.com'
        },
        {
          title: '甘肃建投物业管理集团有限公司 ',
          url: 'http://www.gsjtwy.com'
        },
        {
          title: '甘肃建投物流集团公司 ',
          url: 'http://www.gsjt56.com'
        },
        {
          title: '甘肃省建筑科学研究院有限公司 ',
          url: 'http://www.gsjky.com.cn'
        },
        {
          title: '甘肃一安建设科技集团有限公司 ',
          url: 'http://www.gsya.com.cn'
        },
        {
          title: '甘肃建投生态建设有限公司 ',
          url: 'http://www.gsjtstjs.com'
        },
        {
          title: '甘肃建投上海金播公司 ',
          url: 'http://www.jinbmall.com'
        },
        {
          title: '甘肃建投矿业有限公司 ',
          url: 'http://gsjtky.com'
        },
        {
          title: '甘肃建投隧道工程有限公司 ',
          url: 'http://www.gsjtsd.com'
        },
        {
          title: '甘肃建投建设有限公司 ',
          url: 'http://www.gsjtjs.com'
        },
        {
          title: '甘肃建投重工科技有限公司 ',
          url: 'http://www.gemceqpt.com'
        },
        {
          title: '甘肃建投装备制造有限公司',
          url: 'http://www.gcigcem.com.cn'
        },
        {
          title: '甘肃建投天水建设管理有限公司 ',
          url: 'http://www.gsjtts.com'
        },
        {
          title: '中国甘肃国际经济技术合作总公司',
          url: 'http://www.cgicop.com'
        },
        {
          title: '甘肃建投培训中心 ',
          url: 'http://www.gsjtpxzx.com'
        }
      ],
      linkList02: [
        {
          title: '甘肃省人民政府 ',
          url: 'http://www.gansu.gov.cn/'
        },
        {
          title: '甘肃省住房和城乡建设厅 ',
          url: 'http://zjt.gansu.gov.cn/'
        },
        {
          title: '甘肃省人民政府国有资产监督管理委员会',
          url: 'http://gzw.gansu.gov.cn/'
        },
        {
          title: '甘肃省工业和信息化厅',
          url: 'http://gxt.gansu.gov.cn/'
        },
        {
          title: '甘肃政务服务网',
          url: 'http://www.gszwfw.gov.cn/'
        }
      ],
      linkList03: [
        {
          title: '中国建筑设计行业网 ',
          url: 'http://www.jzsjfh.com/'
        },
        {
          title: '中国施工企业管理协会',
          url: 'http://www.cacem.com.cn/'
        },
        {
          title: '中国建筑经济网 ',
          url: 'http://www.coneco.com.cn/'
        },
        {
          title: '甘肃省土木建筑学会 ',
          url: 'http://www.gstmxh.com/'
        },
        {
          title: '施工技术 ',
          url: 'http://www.shigongjishu.cn/'
        }
      ],
      linkList04: [
        {
          title: '每日甘肃网',
          url: 'http://www.gansudaily.com.cn/'
        },
        {
          title: '甘肃经济网',
          url: 'http://www.gsjb.com/'
        },
        {
          title: '新华网甘肃频道 ',
          url: 'http://www.gs.xinhuanet.com/'
        },
        {
          title: '中国兰州网 ',
          url: 'http://www.lanzhou.cn/'
        },
        {
          title: '中国甘肃网 ',
          url: 'http://www.gscn.com.cn/'
        },
        {
          title: '兰州新闻网',
          url: 'http://www.lzbs.com.cn/'
        },
        {
          title: '凤凰网甘肃 ',
          url: 'http://gs.ifeng.com/'
        },
        {
          title: '人民网甘肃',
          url: 'http://gs.people.com.cn/'
        }
      ],
      companyDecRList01: [],
      companyDecRList02: []
    }
  },
  mounted() {
    this.getTopArtList()
    this.homeNewsCompany()
    this.bannerHomeSec01()
    this.bannerPoint()
    this.bannerHomeNotice()
    this.homeNewsPeriodical()
    this.homeNewsBasic()
    // this.homeNewsDj()
    // this.homeNewsXxjy()
    // this.homeNewsHydt()
    this.caseList()
    this.cultureList()
  },
  filters: {
    //超过100位显示 ...
    ellipsis: function(value) {
      if (!value) return ''
      if (value.length > 48) {
        return value.slice(0, 48) + '...'
      }
      return value
    }
  },
  methods: {
    // 头条
    getTopArtList() {
      var _this = this
      let data = {
        applicationUuid: _this.webId
      }
      getTopArtList(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsTop = data
        }
      })
    },
    // 集团要闻/建投新闻/党的建设
    homeNewsCompany() {
      var _this = this

      let data01 = {
        // channelUuid: '00890001',
        entTApplicationUuid: _this.webIdGroup,
        channelUuid: '00190001',
        pageNum: 1,
        pageSize: 3
      }
      picArticles(data01).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsRight01img = data.rows
        }
      })
      let data1 = {
        entTApplicationUuid: _this.webIdGroup,
        // channelUuid: '00890001',
        channelUuid: '00190001',
        pageNum: 1,
        pageSize: 3
      }
      articles(data1).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsRight01 = data.rows
        }
      })

      let data02 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00890002',
        pageNum: 1,
        pageSize: 3
      }
      picArticles(data02).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsRight02img = data.rows
        }
      })
      articles(data02).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsRight02 = data.rows
        }
      })

      let data03 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00890003',
        pageNum: 1,
        pageSize: 3
      }
      picArticles(data03).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsRight03img = data.rows
        }
      })
      articles(data03).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsRight03 = data.rows
        }
      })
    },
    mouseenterPeriodical(val) {
      var _this = this

      _this.homeDec02ImgUrl = val.thumb1
      _this.homeDec02Url = val.url
    },
    mouseenterNewsHd(val) {
      var _this = this

      _this.activeNewsHd = val
    },
    mouseenterNewsHd01(val) {
      var _this = this

      _this.activeNewsHd01 = val
    },
    mouseenterNewsHdCase(val) {
      var _this = this

      _this.activeNewsHdCase = val
    },
    mouseenterNewsHdCulture(val) {
      var _this = this
      _this.activeNewsHdCulture = val
    },
    mouseenterNewsHdDes02(val) {
      var _this = this

      _this.activeNewsHdDes02 = val
    },
    // 焦点图
    bannerHomeSec01() {
      var _this = this
      // 党得建设
      let data1 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00900003',
        pageNum: 1,
        pageSize: 5
      }
      let data2 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '0091',
        pageNum: 1,
        pageSize: 1
      }
      picArticlesSecond(data2).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.companyDecBox02List = data.rows
          this.$nextTick(() => {
            new Swiper('#companyDecBox02', {
              loop: true,
              autoplay: 2000,
              speed: 300,
              effect: 'fade',
              fade: {
                crossFade: false
              },
              paginationClickable: true,
              pagination: '.swiper-pagination-com02',
              paginationType: 'fraction',
              prevButton: '.swiper-button-prev-com02',
              nextButton: '.swiper-button-next-com02',
              observeSlideChildren: true,
              observer: true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
              autoplayDisableOnInteraction: false //用户操作swiper之后重新启动autoplay
            })
          })
        }
      })
      picArticles(data1).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.companyDecBox01List = data.rows
          this.$nextTick(() => {
            new Swiper('#companyDecBox01', {
              loop: true,
              autoplay: 2000,
              speed: 300,
              effect: 'fade',
              fade: {
                crossFade: false
              },
              paginationClickable: true,
              pagination: '.swiper-pagination-com01',
              paginationType: 'fraction',
              prevButton: '.swiper-button-prev-com01',
              nextButton: '.swiper-button-next-com01',
              observeSlideChildren: true,
              observer: true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
              autoplayDisableOnInteraction: false //用户操作swiper之后重新启动autoplay
            })
          })
        }
      })

      let data01 = {
        // channelUuid: '00890001',
        entTApplicationUuid: _this.webIdGroup,
        channelUuid: '00190001',
        pageNum: 1,
        pageSize: 6
      }
      picArticles(data01).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsLeft01 = data.rows
          this.$nextTick(() => {
            new Swiper('#bannerHomeSec01', {
              loop: true,
              speed: 300,
              autoplay: 3000,
              paginationClickable: true,
              pagination: '.swiper-pagination-sec01',
              observer: true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
              autoplayDisableOnInteraction: false //用户操作swiper之后重新启动autoplay
            })
          })
        }
      })

      let data02 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00890002',
        pageNum: 1,
        pageSize: 6
      }
      picArticles(data02).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsLeft02 = data.rows
          this.$nextTick(() => {
            new Swiper('#bannerHomeSec02', {
              loop: true,
              speed: 300,
              autoplay: 3000,
              paginationClickable: true,
              pagination: '.swiper-pagination-sec02',
              observer: true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
              autoplayDisableOnInteraction: false //用户操作swiper之后重新启动autoplay
            })
          })
        }
      })
      let data03 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00890003',
        pageNum: 1,
        pageSize: 6
      }
      picArticles(data03).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsLeft03 = data.rows
          this.$nextTick(() => {
            new Swiper('#bannerHomeSec03', {
              loop: true,
              speed: 300,
              autoplay: 3000,
              paginationClickable: true,
              pagination: '.swiper-pagination-sec03',
              observer: true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
              autoplayDisableOnInteraction: false //用户操作swiper之后重新启动autoplay
            })
          })
        }
      })
    },
    // 公告
    bannerHomeNotice() {
      var _this = this

      // 党的建设  企业文化
      let data04 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00900003',
        pageNum: 1,
        pageSize: 10
      }
      articles(data04).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.companyDecRList01 = data.rows
        }
      })
      let data05 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '0091',
        pageNum: 1,
        pageSize: 10
      }
      getPageInfo(data05).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.companyDecRList02 = data.rows
        }
      })
    },
    // 基层动态
    homeNewsPeriodical() {
      var _this = this

      let dataTop = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00330006',
        pageNum: 1,
        pageSize: 5
      }
      picArticles(dataTop).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.homeNewsBasicTop01 = data.rows[1]
        }
      })

      let data = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00330006',
        pageNum: 1,
        pageSize: 4
      }
      articles(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.homeNewsBasicList01 = data.rows
        }
      })
    },
    // 战略发展
    homeNewsBasic() {
      var _this = this

      let dataTop = {
        entTApplicationUuid: _this.webId,
        channelUuid: '0042',
        pageNum: 1,
        pageSize: 5
      }
      picArticles(dataTop).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.homeNewsBasicTop02 = data.rows[1]
        }
      })

      let data = {
        entTApplicationUuid: _this.webId,
        channelUuid: '0042',
        pageNum: 1,
        pageSize: 4
      }
      articles(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.homeNewsBasicList02 = data.rows
        }
      })
    },

    // 企业荣誉
    bannerPoint() {
      var _this = this
      let data = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00880004',
        pageNum: 1,
        pageSize: 6
      }
      picArticles(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.pointImgList = data.rows
          this.$nextTick(() => {
            new Swiper('.bannerPoint', {
              effect: 'coverflow',
              grabCursor: true,
              loop: true,
              speed: 300,
              autoplay: 2000,
              slidesPerView: 2.5,
              spaceBetween: 20,
              centeredSlides: true,
              pagination: '.swiper-pagination-honor',
              paginationClickable: true,
              coverflowEffect: {
                rotate: 0,
                stretch: -15,
                depth: 110,
                modifier: 4,
                slideShadows: false
              },
              observer: true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
              autoplayDisableOnInteraction: false //用户操作swiper之后重新启动autoplay
            })
          })
        }
      })
    },
    // 企业业绩
    caseList() {
      var _this = this

      let data01 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00980001',
        pageNum: 1,
        pageSize: 5
      }
      picArticles(data01).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          let list = []
          data.rows.length &&
            data.rows.forEach(line => {
              if (line.thumb1 && line.thumb1 !== '') {
                list.push(line)
              }
            })
          if (data.rows.length) {
            _this.caseList01 = list.slice(1, 5)
            _this.caseList01First = list[0]
          } else {
            _this.caseList01 = []
            _this.caseList01First = {}
          }
        }
      })

      let data02 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00980002',
        pageNum: 1,
        pageSize: 5
      }
      picArticles(data02).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          let list = []
          data.rows.length &&
            data.rows.forEach(line => {
              if (line.thumb1 && line.thumb1 !== '') {
                list.push(line)
              }
            })
          // _this.caseList02 = list.slice(1, 5)
          // _this.caseList02First = list[0]
          if (data.rows.length) {
            _this.caseList02 = list.slice(1, 5)
            _this.caseList02First = list[0]
          } else {
            _this.caseList02 = []
            _this.caseList02First = {}
          }
        }
      })
    },
    // 企业文化
    cultureList() {
      var _this = this

      let dataImg01 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00370001',
        pageNum: 1,
        pageSize: 10
      }
      picArticles(dataImg01).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          let list = []
          data.rows.length &&
            data.rows.forEach(line => {
              if (line.thumb1 && line.thumb1 !== '') {
                list.push(line)
              }
            })
          if (list.length) {
            _this.cultureImg01 = list[0]
          } else {
            _this.cultureImg01 = data.rows[0]
          }
        }
      })

      let dataImg02 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00370002',
        pageNum: 1,
        pageSize: 10
      }
      picArticles(dataImg02).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          let list = []
          data.rows.length &&
            data.rows.forEach(line => {
              if (line.thumb1 && line.thumb1 !== '') {
                list.push(line)
              }
            })
          if (list.length) {
            _this.cultureImg02 = list[0]
          } else {
            _this.cultureImg02 = data.rows[0]
          }
        }
      })

      let dataImg03 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00370003',
        pageNum: 1,
        pageSize: 10
      }
      picArticles(dataImg03).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          let list = []
          data.rows.length &&
            data.rows.forEach(line => {
              if (line.thumb1 && line.thumb1 !== '') {
                list.push(line)
              }
            })
          if (list.length) {
            _this.cultureImg03 = list[0]
          } else {
            _this.cultureImg03 = data.rows[0]
          }
        }
      })

      let dataImg04 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00370004',
        pageNum: 1,
        pageSize: 10
      }
      picArticles(dataImg04).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          let list = []
          data.rows.length &&
            data.rows.forEach(line => {
              if (line.thumb1 && line.thumb1 !== '') {
                list.push(line)
              }
            })
          if (list.length) {
            _this.cultureImg04 = list[0]
          } else {
            _this.cultureImg04 = data.rows[0]
          }
        }
      })

      let dataList01 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '01010001',
        pageNum: 1,
        pageSize: 10
      }
      articles(dataList01).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.cultureList01 = data.rows
        }
      })

      let dataList02 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '01010002',
        pageNum: 1,
        pageSize: 10
      }
      articles(dataList02).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.cultureList02 = data.rows
        }
      })

      let dataList03 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '01010003',
        pageNum: 1,
        pageSize: 10
      }
      articles(dataList03).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.cultureList03 = data.rows
        }
      })

      let dataList04 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '0097',
        pageNum: 1,
        pageSize: 2
      }
      articles(dataList04).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.cultureList04 = data.rows
        }
      })
    },
    // 友情链接
    changeLink01(val) {
      window.open(val)
    },
    changeLink02(val) {
      window.open(val)
    },
    changeLink03(val) {
      window.open(val)
    },
    changeLink04(val) {
      window.open(val)
    }
  }
}
</script>
<style>
.bannerHome {
  height: 620px;
  position: relative;
}

.bannerHome .swiper-wrapper,
.bannerHome .swiper-slide,
.bannerHome img {
  height: 100%;
}

.bannerHome img {
  width: 100%;
}

.swiper-pagination-banner {
  color: #fff;
  font-size: 16px;
}

.swiper-pagination-current {
  font-size: 20px;
}

.bannerHomeSec01 .swiper-wrapper,
.bannerHomeSec01 .swiper-slide,
.bannerHomeSec01 img {
  height: 100%;
}

.bannerHomeSec01 img {
  width: 100%;
  height: 100%;
}

.bannerHomeSec01 .swiper-slide {
  position: relative;
}
.bannerHomeSec01 .swiper-pagination-bullet {
  /* width: 42px;
    height: 42px;
    text-align: center;
    border-radius: 0; */
  background-color: #fff;
  opacity: 1;
}

.bannerHomeSec01 .swiper-pagination-bullet-active {
  background-color: #ce251f;
}

.bannerHomeSec01 .swiper-pagination .swiper-pagination-current {
  font-size: 30px;
  font-size: 16px;
}

/* 友情链接 */
.sec_zfgs_list a {
  display: block;
  text-align: center;
  line-height: 34px;
  border: 1px solid #d5d5d5;
  margin-bottom: 6px;
}

.sec_zfgs_list a:hover {
  border-color: #2b78c6;
  color: #fff;
  background-color: #2b78c6;
}

.homeNotice {
  height: 60px;
  line-height: 60px;
  background-color: #f3f3f3;
  margin: 30px 0;
  padding: 0 35px;
  text-align: center;
}

.homeNoticeL {
  width: 57px;
  height: 28px;
  overflow: hidden;
  border: solid 1px #0d65ac;
  line-height: 28px;
  margin: 17px 0px 0px 0;
  box-sizing: border-box;
}

.homeNoticeBox {
  margin-left: 88px;
  height: 100%;
}

.bannerHomeNotice a {
  font-size: 18px;
}

.bannerHomeNotice a:hover {
  color: #0d65ac;
}

.bannerHomeNotice .swiper-slide {
  width: 300px;
  width: auto;
}

#bannerHomeNotice > .swiper-wrapper {
  -webkit-transition-timing-function: linear;
  /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
  margin: 0 auto;
}

.homeDec02 {
  margin-bottom: 40px;
}

.homeDec02Img {
  height: 310px;
  overflow: hidden;
  margin-bottom: 15px;
  /* padding: 7px 8px; */
  /* border: solid 1px #D9D2C2; */
}

.homeDec02Img img,
.homeDec02BottomImg img {
  width: 100%;
  height: 100%;
  -moz-transition: all 0.3s ease-in;
  -webkit-transition: all 0.3s ease-in;
  -o-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}

.homeDec02Img img:hover,
.homeDec02BottomImg img:hover {
  -moz-transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -o-transform: scale(1.1);
  transform: scale(1.1);
}

.homeDec02BottomImg {
  height: 171px;
  overflow: hidden;
}

.homeDec02Bottom {
  margin-top: 30px;
}

.homeNewsBasicTop p a:hover {
  text-decoration: underline;
}

.homeDec03 {
  margin-top: 30px;
}

.homeTopNewTitle {
  width: 62px;
  height: 62px;
  background-color: #017bce;
  padding: 10px;
  color: #ffffff;
  font-size: 18px;
  letter-spacing: 2px;
  line-height: 20px;
  text-align: center;
  font-weight: bold;
  margin-top: 15px;
  float: left;
  box-sizing: border-box;
}

.nav_tabs {
  width: 100%;
  height: 70px;
  overflow: hidden;
  background-image: url(../assets/img_sj/company_title.png);
  background-position: left bottom;
  background-repeat: no-repeat;
}

.nav_tabs_li {
  width: 188px;
  height: 48px;
  overflow: hidden;
  float: left;
  text-align: center;
}

.nav_tabs_li a {
  width: 100%;
  display: inline-block;
  color: #04090e;
  font-size: 24px;
  line-height: 44px;
  padding: 0px !important;
  border-bottom: solid 2px #d3d3d3;
}
.nav_tabs_li_1 {
  width: 188px;
  height: 48px;
  overflow: hidden;
  float: left;
  text-align: center;
}
.nav_tabs_li_1_r {
  width: 392px;
  height: 44px;
  float: right;
  border-bottom: solid 2px #d3d3d3;
}

.nav_tabs_li_1 a {
  width: 100%;
  display: inline-block;
  color: #04090e;
  font-size: 24px;
  line-height: 44px;
  padding: 0px !important;
  border-bottom: solid 2px #d3d3d3;
}

.last_li {
  height: 48px;
  overflow: hidden;
  float: left;
  text-align: center;
  width: 636px;
}

.last_li div {
  height: 44px;
  border-bottom: solid 2px #d3d3d3;
}

.nav_tabs_li.active {
  background-image: url(../assets/img_sj/title_bg.png);
  background-position: left bottom;
  background-repeat: no-repeat;
}

.nav_tabs_li.active a {
  border-bottom: none;
}
.nav_tabs_li_1.active {
  background-image: url(../assets/img_sj/title_bg.png);
  background-position: left bottom;
  background-repeat: no-repeat;
}

.nav_tabs_li_1.active a {
  border-bottom: none;
}

.big_List li {
  height: 150px;
  overflow: hidden;
  border-bottom: dashed 1px #dedede;
  padding-top: 22px;
}

.big_List_L {
  width: 80px;
  height: auto;
  overflow: hidden;
  float: left;
}

.big_List_L .u {
  height: 60px;
  overflow: hidden;
  font-size: 36px;
  color: #333333;
  line-height: 80px;
  font-weight: 700;
  text-align: center;
}

.big_List_L .d {
  height: 20px;
  overflow: hidden;
  font-size: 14px;
  color: #888888;
  line-height: 20px;
  font-weight: 700;
  text-align: center;
}

.big_List_R {
  width: 534px;
  height: auto;
  overflow: hidden;
  float: right;
  cursor: pointer;
}

.big_List_R_l {
  width: 114px;
  height: 98px;
  float: left;
}

.big_List_R_r {
  float: right;
  width: 370px;
  height: auto;
  overflow: hidden;
}

.big_List_R_r_top {
  height: 48px;
  overflow: hidden;
  line-height: 24px;
  font-size: 16px;
  color: #333333;
}

.big_List_R_r_artDesc {
  display: inline-block;
  width: 100%;
  padding: 20px 0;
  height: 48px;
  overflow: hidden;
  font-size: 14px;
  color: #888888;
  line-height: 24px;
}

.big_List_R_r_top:hover {
  font-weight: 700;
}

.big_List_R_r_artDesc:hover {
  font-weight: 700;
}

.companyDecBox01 .swiper-wrapper,
.companyDecBox01 .swiper-slide,
.companyDecBox01 img {
  height: 100%;
}

.companyDecBox01 img {
  width: 100%;
  height: 100%;
}

.companyDecBox01 .swiper-slide {
  position: relative;
}

.companyDecBox01 .swiper-pagination-bullet {
  width: 44px;
  height: 44px;
  text-align: center;
  border-radius: 0;
  background-color: rgba(0, 0, 0, 0.2);
  opacity: 1;
}

.companyDecBox01 .swiper-pagination-bullet-active {
  background-color: #ce251f;
}

.companyDecBox01 .swiper-pagination .swiper-pagination-current {
  font-size: 30px;
}
.index_about_panel {
  width: 100%;
  background-image: url(../assets/img_sj/about_bg.jpg);
  background-position: center top;
  background-repeat: no-repeat;
  padding-top: 1px;
  background-size: 100% 44%;
}
.index_about_panel .content {
  width: 1231px;
  min-height: 667px;
  margin: 176px auto 0 auto;
  background-image: url(../assets/img_sj/about_us_bg.png);
  background-position: center top;
  background-repeat: no-repeat;
}
.main_1200 {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.index_about_panel .content .d {
  overflow: hidden;
  margin-top: 70px;
}
.index_about_panel .content .u .picture {
  width: 485px;
  height: 295px;
  overflow: hidden;
  margin: 63px 0 0 67px;
  float: left;
}
.index_about_panel .content .u .text {
  width: 600px;
  height: auto;
  overflow: hidden;
  margin-top: 55px;
  float: right;
}
.index_about_panel .content .u .text .t {
  width: 100%;
  height: 60px;
  overflow: hidden;
  background-image: url(../assets/img_sj/about_us_title.png);
  background-position: left bottom;
  background-repeat: no-repeat;
}
.index_about_panel .content .u .text .t .t_l {
  width: 188px;
  height: 46px;
  overflow: hidden;
  background-image: url(../assets/img_sj/title_bg.png);
  background-position: left bottom;
  background-repeat: no-repeat;
  text-align: center;
  float: left;
}
.index_about_panel .content .u .text .t .t_l a {
  color: #04090e;
  font-size: 24px;
  line-height: 42px;
  padding: 0px !important;
}
.index_about_panel .content .u .text .t .t_r {
  width: 412px;
  height: 46px;
  overflow: hidden;
  float: right;
}
.index_about_panel .content .u .text .t .t_r div {
  height: 44px;
  border-bottom: solid 2px #d3d3d3;
}
.index_about_panel .content .u .text .intro {
  overflow: hidden;
  color: #333333;
  font-size: 18px;
  line-height: 30px;
  text-indent: 24px;
  margin-top: 28px;
  margin-right: 60px;
}
.index_about_panel .content .u .text .check_more {
  width: 149px;
  height: 40px;
  overflow: hidden;
  border: solid 2px #bb1519;
  text-align: center;
  margin-top: 50px;
  margin-right: 60px;
  float: right;
}
.index_about_panel .content .u .text .check_more a {
  color: #333333;
  font-size: 18px;
  line-height: 40px;
  font-weight: 500;
}
.index_about_panel .content .d .about_cate ul li {
  width: 126px;
  height: auto;
  overflow: hidden;
  float: left;
  margin: 0 137px;
  text-align: center;
}
.index_about_panel .content .d .about_cate ul li a {
  display: block;
  cursor: pointer;
  width: 126px;
  height: auto;
  color: #333333;
  font-size: 18px;
  line-height: 72px;
  padding-top: 126px;
  background-position: left top;
  background-repeat: no-repeat;
  background-size: 126px 126px;
}
.index_about_panel .content .d .about_cate ul li a:hover {
  font-weight: 700;
}
.index_about_panel .content .d .about_cate ul li.item1 a {
  background-image: url(../assets/img_sj/about_item_n1.png);
}
.index_about_panel .content .d .about_cate ul li.item2 a {
  background-image: url(../assets/img_sj/about_item_n2.png);
}
.index_about_panel .content .d .about_cate ul li.item4 a {
  background-image: url(../assets/img_sj/about_item_n4.png);
}
.index_about_panel .content .d .about_cate ul li.item1 a:hover {
  background-image: url(../assets/img_sj/about_item_h1.png);
}
.index_about_panel .content .d .about_cate ul li.item2 a:hover {
  background-image: url(../assets/img_sj/about_item_h2.png);
}
.index_about_panel .content .d .about_cate ul li.item4 a:hover {
  background-image: url(../assets/img_sj/about_item_h4.png);
}
.honorDec .t {
  width: 100%;
  height: 74px;
  overflow: hidden;
  background-image: url(../assets/img_sj/company_honor_title.png);
  background-position: 505px bottom;
  background-repeat: no-repeat;
}
.honorDec .t .t_l {
  width: 506px;
  height: 46px;
  overflow: hidden;
  float: left;
}
.honorDec .t .t_l div {
  height: 44px;
  border-bottom: solid 2px #d3d3d3;
}
.t .t_c {
  width: 188px;
  height: 48px;
  overflow: hidden;
  background-image: url(../assets/img_sj/title_bg.png);
  background-position: left bottom;
  background-repeat: no-repeat;
  text-align: center;
  float: left;
}
.t .t_c a {
  color: #04090e;
  font-size: 24px;
  line-height: 42px;
  padding: 0px !important;
  text-align: center;
}
.t .t_r {
  width: 506px;
  height: 46px;
  overflow: hidden;
  float: left;
}
.t .t_r div {
  height: 44px;
  border-bottom: solid 2px #d3d3d3;
}
.jcjbimg {
  width: 580px;
  display: inline-block;
  margin-top: 60px;
}
.jcjbimg img {
  width: 100%;
}
.linkBox .el-input__inner {
  background: rgb(233, 233, 237);
  border: 1px solid #737476;
  color: #29292a;
}
</style>
